import { BrandMarquee } from './brand-marquee';
import { BrandMarqueeFields } from "./brand-marquee.fields";
import type { BrandMarqueeProps } from './brand-marquee';
import type { ComponentConfig } from "@puckeditor/core";
import { ImagePicker } from "../editor/ImagePicker";
import { RegenerableTextField } from "../editor/RegenerableTextField";

const BrandMarqueeConfig: ComponentConfig<BrandMarqueeProps> = {
  defaultProps: {
    brands: [
      { href: "", logoUrl: "", name: "Brand 1" },
      { href: "", logoUrl: "", name: "Brand 2" },
      { href: "", logoUrl: "", name: "Brand 3" },
      { href: "", logoUrl: "", name: "Brand 4" },
      { href: "", logoUrl: "", name: "Brand 5" },
      { href: "", logoUrl: "", name: "Brand 6" },
    ],
    chipStyle: "pill",
    displayMode: "mixed",
    heading: "Brands We Work With",
    mediaStyle: "logo",
    scrolling: "yes",
    shadow: "yes",
    spacing: "default",
    subheading: "Trusted products from the manufacturers we know best.",
  },
  fields: {
    heading: {
      ...BrandMarqueeFields.heading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="brandMarquee.heading"
          label="Heading"
          multiline={false}
          fieldMeta={field?.metadata}
        />
      ),
    },
    subheading: {
      ...BrandMarqueeFields.subheading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="brandMarquee.subheading"
          label="Subheading"
          multiline={true}
          fieldMeta={field?.metadata}
        />
      ),
    },
    displayMode: BrandMarqueeFields.displayMode,
    mediaStyle: BrandMarqueeFields.mediaStyle,
    scrolling: BrandMarqueeFields.scrolling,
    spacing: BrandMarqueeFields.spacing,
    chipStyle: BrandMarqueeFields.chipStyle,
    shadow: BrandMarqueeFields.shadow,
    brands: {
      ...BrandMarqueeFields.brands,
      arrayFields: {
        ...BrandMarqueeFields.brands.arrayFields,
        logoUrl: {
          ...BrandMarqueeFields.brands.arrayFields.logoUrl,
          render: ({
            value,
            onChange,
          }: {
            value?: string;
            onChange: (val: string | undefined) => void;
          }) => <ImagePicker value={value || ""} onChange={onChange} label="Logo" />,
        },
      },
    } as any,
    backgroundColor: BrandMarqueeFields.backgroundColor,
  },
  label: "Brand Marquee",
  render: ({ id, puck: _puck, ...props }) => <BrandMarquee id={id} {...props} />,
  /**
   * The shadow only lands on a chip surface, and a logo URL is never read when brands render
   * as names.
   */
  resolveFields: (data, { fields }) => {
    const props = (data.props || {}) as { chipStyle?: string; displayMode?: string },
      visible = { ...(fields as Record<string, any>) };

    if (props.chipStyle === "none") {
      delete visible.shadow;
    }

    if (props.displayMode === "names" && visible.brands?.arrayFields?.logoUrl) {
      const { logoUrl: _logoUrl, ...arrayFields } = visible.brands.arrayFields;
      visible.brands = { ...visible.brands, arrayFields };
    }

    // Image style only changes how uploaded images render.
    if (props.displayMode === "names") {
      delete visible.mediaStyle;
    }

    return visible as typeof fields;
  },
};

export { BrandMarqueeConfig };
